import { Box } from '@mui/material';

import Typography from '@/components/Typography';
import { NameInput } from '@/components/NameInput';
import { TABNAME_MAX_LENGTH } from '@/features/Dashboard/constants/const';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';

export const TabName = () => {
  const { form, setCanPreview } = useAppForm();
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        pb: 3
      }}
    >
      <Typography
        size={14}
        sx={{ fontWeight: 700, mb: 1 }}
      >
        Tab title
      </Typography>
      <Typography
        size={12}
        sx={{ fontWeight: 500, color: 'gx.textDisabled', mb: 2 }}
      >
        Give your tab a meaningful name
      </Typography>
      <form.Field
        children={field => (
          <NameInput
            error={form.state.errorMap.onChange?.name}
            maxLength={TABNAME_MAX_LENGTH}
            value={field.state.value}
            onBlur={() => {
              setCanPreview(true);
            }}
            onChange={field.handleChange}
            onFocus={() => {
              setCanPreview(false);
            }}
            {...field}
          />
        )}
        name='name'
      />
    </Box>
  );
};
